import { render, staticRenderFns } from "./WordList.vue?vue&type=template&id=4efe6d02&scoped=true"
import script from "./WordList.vue?vue&type=script&lang=js"
export * from "./WordList.vue?vue&type=script&lang=js"
import style0 from "./WordList.vue?vue&type=style&index=0&id=4efe6d02&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4efe6d02",
  null
  
)

export default component.exports